
export class Controller {

    /** @ngInject */
    constructor($state,Alert, Authenticator) {
        this.Alert = Alert;
        this.$state=$state;
        this.Authenticator = Authenticator;
    }

    $onInit() {
        this.isAuthenticator = this.type == 'authenticator'
        this.tooltipTemplate = require('../../../company/sharing-center/secret-tooltip.html');
        if(this.copyAccount != null) {
            this.account = this.copyAccount;
            this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
        } else {
            this.account = {
                algorithm: 'SHA1',
                digits: 6,
            };
        }
        if (this.isAuthenticator) {
            this.publicServicesWithSsoAnd2FA$.get().then(items => this.publicServices=items);
        } else {
            this.publicServicesWithSso$.get().then(items => this.publicServices=items);
        }
    }

    save() {
        this.isSaving = true;
        let publicServiceKey = null;
        if (this.isAuthenticator) {
            publicServiceKey = generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.account.secret,
                    this.account.digits,
                    this.account.algorithm
                )
        }
        this.Authenticator.create(
            {
                publicServiceId: this.account.publicService.id,
            },
            {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: this.isAuthenticator,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: publicServiceKey
            }
        )
            .$promise
            .then(account => {
                this.$state.go('^.edit',{publicUserAccountId: account.id}, {reload: "^"});
                if (this.isAuthenticator) {
                    this.Alert('success', 'user.public-user-accounts.add.authenticator.added');
                } else {
                    this.Alert('success', 'user.public-user-accounts.add.password-manager.added');
                }
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || !this.account.publicService;
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.publicServices.find(i => i.slug === "other");
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/add/add-public-user-account.controller.js